export default __webpack_public_path__ + "assets/wizard-fulfilment-d4707ded71c5238c30fd6359f86242dd.svg";